


































import { Component, Vue, } from "@/shared/vuepack";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { UserTermsType } from "@/shared/types";

@Component({
  components: {
    Checkbox
  }
})
export default class ClaimAccountTerms extends Vue {
  enrollmentStore = useEnrollmentStore();

  selectedTermsAccepted = false;
  isSubmitting = false;
  isFormDirty = false;

  onCheck (): void {
    this.isFormDirty = true;
    this.selectedTermsAccepted = !this.selectedTermsAccepted;
  }

  readonly bendTermsAndConditionsFile = "bend_financial_terms_of_service 20181009.pdf";

  get disableSubmit (): boolean {
    return !this.selectedTermsAccepted || this.isSubmitting;
  }

  submitAcceptedTerms (): void {
    if (this.selectedTermsAccepted && !this.isSubmitting) {
      this.isSubmitting = true;
      this.enrollmentStore.saveAgreedToTerms(this.bendTermsAndConditionsFile, UserTermsType.Wizard)
          .then(() => this.enrollmentStore.termsAccepted())
          .then(() => {
            this.isSubmitting = false;
          })
          .then(() => this.$emit("complete"))
          .catch(() => this.isSubmitting = false);
    }
  }
}
